import React from "react";
import PropTypes from "prop-types";

import { Translate } from "utils";

import Area from "./Area";
import Capacity from "./Capacity";

import styles from "./SpaceSizeEdit.css";

const { t } = new Translate();

const AreaPrimary = ({ area, capacity, onChangeArea, onChangeCapacity }) => (
  <div className={styles.root}>
    <Area area={area} onChange={onChangeArea} />
    <div className={styles.small}>{t("with")}</div>
    <Capacity capacity={capacity} onChange={onChangeCapacity} />
  </div>
);

AreaPrimary.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  onChangeArea: PropTypes.func.isRequired,
  onChangeCapacity: PropTypes.func.isRequired,
};

export default AreaPrimary;
